import { Source, Layer, Popup, FillLayer, CircleLayer, LineLayer } from 'react-map-gl';
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import settings from "./../../settings.json";
import { useState, useContext, useEffect, useMemo } from 'react';
import { RefContext } from "./../../RefContext";
import { PointContext } from "./../../PointContext";
import { ActivePopupContext } from './../../ActivePopupContext';
import { v4 as uuidv4 } from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { adjustHexBrightness } from './../../features/utils';

const FHO = ({ id, url, opacity, global }: any) => {
  let rangeSel = "nws";  
  let categorySel = "observed";  
  let _currentUrl = 'https://mapservices.weather.noaa.gov/experimental/services/owp_fho/MapServer/WFSServer?request=GetFeature&outputFormat=GEOJSON&service=WFS&typeName=owp_fho:Days_1-7'
  let _imageUrl = `https://mapservices.weather.noaa.gov/experimental/rest/services/owp_fho/MapServer/export?bbox={bbox-epsg-3857}&dpi=96&transparent=true&format=png32&layers=show:0,1,2&bboxSR=102100&imageSR=102100&f=image`
  let _gaugeUrl = `https://mapservices.weather.noaa.gov/eventdriven/services/water/riv_gauges/MapServer/WFSServer?request=GetFeature&outputFormat=GEOJSON&TYPENAME=riv_gauges_new:Observed_River_Stages&service=WFS&MAXFEATURES=400&Filter=<Filter><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>major</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>minor</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>moderate</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>action</Literal></PropertyIsEqualTo></Filter>`
  let _gaugeFUrl = `https://mapservices.weather.noaa.gov/eventdriven/services/water/riv_gauges/MapServer/WFSServer?request=GetFeature&outputFormat=GEOJSON&TYPENAME=riv_gauges_new:Full_Forecast_Period_Stages&service=WFS&MAXFEATURES=400&Filter=<Filter><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>major</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>minor</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>moderate</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Flood_Status</PropertyName><Literal>action</Literal></PropertyIsEqualTo></Filter>`
  let _sfUrl = `https://mapservices.weather.noaa.gov/vector/services/outlooks/sig_riv_fld_outlk/MapServer/WFSServer?request=GetFeature&srsName=EPSG:4326&outputFormat=GEOJSON&TYPENAME=sig_riv_fld_outlk:Flood_Outlook&service=WFS&MAXFEATURES=400`
  let _hUrl = `https://mapservices.weather.noaa.gov/eventdriven/services/WWA/watch_warn_adv/MapServer/WFSServer?request=GetFeature&outputFormat=GEOJSON&service=WFS&typeName=watch_warn_adv:WatchesWarnings&MAXFEATURES=200&Filter=<Filter><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Flood Warning</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Flood Watch</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Coastal Flood Advisory</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Flood Advisory</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Coastal Flood Warning</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Lakeshore Flood Watch</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Coastal Flood Watch</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Lakeshore Flood Warning</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Flash Flood Warning</Literal></PropertyIsEqualTo><PropertyIsEqualTo><PropertyName>Hazard_Type</PropertyName><Literal>Flash Flood Watch</Literal></PropertyIsEqualTo></Filter>`
  let _mUrl = `https://maps.water.noaa.gov/server/services/rfc/rfc_based_5day_max_streamflow//MapServer/WFSServer?request=GetFeature&srsName=EPSG:4326&outputFormat=GEOJSON&TYPENAME=rfc_based_5day_max_streamflow:__Days_-_Max_Flood_Status_Forecast_-_Action___Only&service=WFS&MAXFEATURES=400`
  let _mIUrl = `https://maps.water.noaa.gov/server/services/nwm/mrf_gfs_5day_max_inundation_extent/MapServer/WFSServer?request=GetFeature&srsName=EPSG:4326&outputFormat=GEOJSON&TYPENAME=mrf_gfs_5day_max_inundation_extent:__Days_-_Inundation_Extent__EXPERIMENTAL_&service=WFS&MAXFEATURES=400`


/*
  https://mapservices.weather.noaa.gov/tropical/rest/services/tropical/NHC_tropical_weather_summary/MapServer

  https://mapservices.weather.noaa.gov/static/rest/services/NWS_FIM/FIM_hldf1/MapServer/export?bbox=-9174852.972372698%2C3365465.734045495%2C-9159348.308127305%2C3379292.8444545004&bboxSR=102100&imageSR=102100&size=1372%2C1224&dpi=144&format=png32&transparent=true&layers=show%3A5,7,15&f=image
  
  https://mapservices.weather.noaa.gov/static/rest/services/NWS_FIM/FIM_hldf1/MapServer?f=pjson













  https://api.weather.gov/products?location=NWC&type=hmd

  https://api.weather.gov/products/ec29ac59-7287-46ba-8c68-36f3ee25c0e8

  https://water.noaa.gov/alerts/HLDF1

  https://api.water.noaa.gov/nwps/v1/gauges/HLDF1

  https://api.water.noaa.gov/nwps/v1/gauges/HLDF1/stageflow

  https://maps.water.noaa.gov/server/rest/services/nwm/ana_inundation_extent/MapServer/0/query?where=oid%3D1&outFields=update_time&returnGeometry=false&f=json


https://mapservices.weather.noaa.gov/vector/rest/services/obs/NWM_Stream_Analysis/MapServer/1/query?where=tile_id%3D0+AND+stream_order%3D5&outFields=Cg_valid_time&returnGeometry=false&f=pjson

https://viewer-api.weather.noaa.gov/wms-p/42879/MapServer
  https://maps.water.noaa.gov/server/rest/services/nwm/mrf_nbm_5day_max_inundation_extent/MapServer

https://maps.water.noaa.gov/server/rest/services/rfc/rfc_based_5day_max_streamflow/MapServer/legend?f=pjson
  
NWM 5-Day Max Forecast (NBM) (Zoom level 18+)

https://maps.water.noaa.gov/server/services/rfc/rfc_based_5day_max_streamflow/MapServer/
https://maps.water.noaa.gov/server/services/rfc/rfc_based_5day_max_streamflow/MapServer/WFSServer?request=GetFeature&srsName=EPSG:4326&outputFormat=GEOJSON&TYPENAME=rfc_based_5day_max_streamflow:__Days_-_Related_RFC_Forecast_Points&service=WFS&MAXFEATURES=400

https://maps.water.noaa.gov/server/services/rfc/rfc_based_5day_max_streamflow//MapServer/WFSServer?request=GetFeature&srsName=EPSG:4326&outputFormat=GEOJSON&TYPENAME=rfc_based_5day_max_streamflow:__Days_-_Max_Flood_Status_Forecast_-_Action___Only&service=WFS&MAXFEATURES=400
*/

  const [popupInfo, setPopupInfo] = useState<any>([]);
  const { activePopup, setActivePopup } = useContext<any>(ActivePopupContext);

  const [currentUrl, setCurrentUrl] = useState<any>(_currentUrl);
  const [imageUrl, setImageUrl] = useState<any>(_imageUrl);
  const [gaugeUrl, setGaugeUrl] = useState<any>(_gaugeUrl);
  const [gaugeFUrl, setGaugeFUrl] = useState<any>(_gaugeFUrl);
  const [sfUrl, setsfUrl] = useState<any>(_sfUrl);
  const [hUrl, sethUrl] = useState<any>(_hUrl);
  const [mUrl, setmUrl] = useState<any>(_mUrl);
  const [mIUrl, setmIUrl] = useState<any>(_mIUrl);

  const [currentRange, setCurrentRange] = useState<any>(rangeSel);
  const [currentCategory, setCurrentCategory] = useState<any>(categorySel);  

  const { currentRef } = useContext(RefContext);
  const { setCurrentPoint } = useContext<any>(PointContext);
  // @ts-ignore
  const mapInstance = currentRef && currentRef?.current;



useEffect(() => {
   if(mapInstance){
            let imageWords = ['day3limited', 'day4limited', 'day7limited','day3considerable', 'day4considerable', 'day7considerable','day3catastrophic'];
            let label = 'striped';
             const loadMapImage = (label: any) => {
                    mapInstance.loadImage(
                      `/mapimages/${label}.png`,   
                      (error:any, image:any) => {
                          if (error) console.log(error);
                          if (!mapInstance.hasImage(label) && !error) mapInstance.addImage(label, image);
                      })
                  }
                  for (var i = 0; i < imageWords.length; i++) {
                    loadMapImage(imageWords[i])
                  }
    }
  }, [mapInstance]);


  useMemo(() => mapInstance && mapInstance.on('click', (event: any) => {
    const queryObject = mapInstance.queryRenderedFeatures(event.point);
    let layerObject = [] as any; 
    for (let i = 0; i < queryObject.length + 1; i++) {
      if (queryObject[i] && queryObject[i].layer && (queryObject[i].layer.id === `${id}-layer`||queryObject[i].layer.id === `${id}-layerG`)) {
        queryObject[i].properties["centroid_longitude"] = event.lngLat.lng;
        queryObject[i].properties["centroid_latitude"] = event.lngLat.lat
        layerObject.push(queryObject[i].properties);
      }
    }
 
     for (let i = 0; i < queryObject.length + 1; i++) {
      if (queryObject[i] && queryObject[i].layer && (queryObject[i].layer.id === `${id}-layerGF`||queryObject[i].layer.id === `${id}-layerS`||queryObject[i].layer.id === `${id}-layerH`||queryObject[i].layer.id === `${id}-layerM`) ) {
        queryObject[i].properties["centroid_longitude"] = event.lngLat.lng;
        queryObject[i].properties["centroid_latitude"] = event.lngLat.lat
        layerObject.push(queryObject[i].properties);
      }
    }

    if (layerObject && layerObject.length > 0) {
      if (layerObject[0]["centroid_longitude"] && !isNaN(layerObject[0]["centroid_longitude"]) && layerObject[0]["centroid_latitude"] && !isNaN(layerObject[0]["centroid_latitude"])) {
        setPopupInfo(layerObject);
        setActivePopup({
          id,
          content: renderPopup(layerObject)
        });
      }
    }
  }), [mapInstance]);



  const renderThumb = (style: any) => {
    const thumbStyle = {
      backgroundColor: 'white'
    };
    return (
      <div style={{ ...style, ...thumbStyle }} />
    );
  }

  let importOrder = [
    "000",
    "Max_Status", "max_status", "Max Status", " Max Status", "Max Status ", 
    "Name",
    "Max_Streamflow__cfs_", 
    "Hazard_Type",
    "MAXFEATURES",
    "Guage_Location",
    "outlook",
    "valid_time",
    "State",
    "Water_Body",    
    "Observed",
    "Units",
    "Flood_Status",
    "Forecast_Guage_Level_Value",
    "Hydrograph",
    "Region",
    "Category",  
    "Gauge_ID",
    "Issued_Time",
    "Alert_Type",
    "Forecast_Office",
    "Ends",
    "Water_Level_In_Need_of_Action",
    "Secondary_Forecast_Value",
    "NWM_Feature_ID",
    "Associated_NWS_LID",
    "Has_Forecast_Point",
    "Message_ID",
    "GIS_File_Date",
    "GIS_Ingest_Date",
    "Longitude",
    "Latitude",
    "centroid_longitude",
    "centroid_latitude"
  ]


const sortByObject: any = importOrder
    .reduce((obj, item, index) => {
      return {
        ...obj,
        [item]: index,
        };
    }, {});

  const popoverHydro = (
    <Popover style={{height: 580, width: 840}} id="mapslider-categories-popover" className="mapslider-categories-popover" key={"mapslider-categories-popover-"}>
      <Popover.Header as="h3">NOAA/National Weather Service Precipitation Analysis</Popover.Header>
      <Popover.Body  className="mapslider-categories-popover-body" >
            <iframe id="iframeModalWindow" style={{height: 480, width: 740}} src="https://water.noaa.gov/gauges/crmf1#official-CRMF1" name="iframe_modal"></iframe>
      </Popover.Body>
    </Popover>
  );

  const pickColor = (item: string) => {
    if(item){
      if(item==='major'){
        return '#bf7fbf'
      } else if(item==='minor'){
        return '#ffff7f'
      } else if(item==='moderate'){
        return '#ff3232'
      } else {
        return 'white'
      }
    } else {
      return 'white'
    }
  }

/*
              <OverlayTrigger trigger="click" placement="right" overlay={popoverHydro}>
                  <Button variant="success">Click to see</Button>
              </OverlayTrigger>
            <div>
              <OverlayTrigger trigger="click" placement="right" overlay={popoverHydro}>
                <Button variant="success">Click to see</Button>
              </OverlayTrigger>
               </div>
*/


  const renderFields = (objectMapArray: any) => {
    return objectMapArray.map((objectMap: any, index: any) => {
/*      if(objectMap.Max_Status){
        objectMap["Max Status"] = objectMap.Max_Status;
      }*/
      let sortedFields = Object.entries(objectMap).sort((a: any, b: any) => sortByObject[a[0]] - sortByObject[b[0]]);

      return sortedFields.map((element: any, index: any) => {
        const skipFields = ['layerName', 'counts', 'results', 'radius', 'Message_ID', 'GmlID', 'OBJECTID', 'Object_ID', 'objectid', 'id'];
        if (skipFields.indexOf(element[0]) > -1) {
          return null;
        } else if (element[0] === 'URL') {
          return (
            <p className="GD-p-comid" key={uuidv4()}>
              <span style={{ opacity: .9 }}>{'URL:'}</span>
              <span style={{ marginLeft: 10, fontSize: '1.3em', opacity: 1 }}>
                <a href={element[1]} target={'_blank'}>More information at NOAA's NWS</a>
              </span>
            </p>
          )
        } else if (element[0] === 'Hydrograph') {
          return (
            <div>
           <div>

               </div>
            <p className="GD-p-comid" key={uuidv4()}>
              <span style={{ opacity: .9 }}>{'URL:'}</span>
              <span style={{ marginLeft: 10, fontSize: '1.3em', opacity: 1 }}>
                <a href={element[1]+'#uk-switcher-1'} target={'_blank'}>Navigate to NOAA's Hydrograph</a>
              </span>
            </p>
            </div>
           
          )
        }else if (element[0] === 'Forecast_Office' && element[1] && element[1].length > 2) {
          return (
            <p className="GD-p-comid" key={uuidv4()}>
              <span style={{ opacity: .9 }}>{'Forecast_Office'}:</span>
              <span style={{ marginLeft: 10, fontSize: '1.3em', opacity: 1 }}>
                <a href={`https://www.weather.gov/${element[1].substr(0, 10)}`} target={'_blank'}>Navigate to NWS {element[1]}</a>
              </span>
            </p>
          )
        } else if (element[0] === 'centroid_latitude') {
          return (
            <div key={uuidv4()} >
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.3em', opacity: 1 }}>    {element[1]} </span>
              </p>
              <hr key={uuidv4()} style={{ marginBottom: 20 }} />
              <hr key={uuidv4()} style={{ marginBottom: 10 }} />
            </div>
          )
        }  else if (element[0] === 'Flood_Status') {

          return (
            <div key={uuidv4()} >
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.5em', opacity: 1 }}>
                  <span style={{ color: pickColor(element[1]) }} >{element[1]}</span> 
                </span>
              </p>
              <hr key={uuidv4()} style={{ marginBottom: 10,  width: 200, marginLeft: "20%" }} />
            </div>
          )
        } else if (element[0] === 'Guage_Location') {
       
          return (

            <div key={uuidv4()} style={{ marginTop: 10}}>
                {objectMap && objectMap.Observed && objectMap.Observed!=="null" && ( <h4>Current Observed Values</h4>  )}
                {objectMap && objectMap.Observed && objectMap.Observed==="null" && ( <h4>Forecasted Values</h4>  )}
                {objectMap && objectMap.outlook && objectMap.outlook!=="null" && ( <h4>River Flooding Outlook</h4>  )}
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.5em', opacity: 1 }}>
                  <span  >{element[1]}</span> 
                </span>
              </p>
            </div>
          )
        } else if (element[0] === 'outlook') {
       
          return (
                
            <div key={uuidv4()} style={{ marginTop: 10}}>

                {objectMap && objectMap.outlook && objectMap.outlook!=="null" && ( <h4>River Flooding Outlook</h4>  )}
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.5em', opacity: 1 }}>
                  <span  >{element[1]}</span> 
                </span>
              </p>
            </div>
          )
        } else if (element[0] === 'Region') {
       
          return (
                
            <div key={uuidv4()} style={{ marginTop: 10}}>

                {objectMap && objectMap.Region && objectMap.Region!=="null" && ( <h4>Flood Hazard Outlook</h4>  )}
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.5em', opacity: 1 }}>
                  <span  >{element[1]}</span> 
                </span>
              </p>
            </div>
          )
        }  else if (element[0] === 'Hazard_Type') {
       
          return (
              
            <div key={uuidv4()} style={{ marginTop: 10}}>

                {objectMap && objectMap.Hazard_Type && objectMap.Hazard_Type!=="null" && ( <h4>NWS Hazard Alert</h4>  )}
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.5em', opacity: 1 }}>
                  <span  >{element[1]}</span> 
                </span>
              </p>
            </div>
          )
        } else if (element[0] === 'Name') {
       
          return (
              
            <div key={uuidv4()} style={{ marginTop: 10}}>

                {objectMap && objectMap.Max_Status && objectMap.Max_Status!=="null" && ( <h4>5day Max Streamflow </h4>  )}
              <p className="GD-p-comid" key={uuidv4()} >
                <span style={{ opacity: .9 }}>{element[0]}:</span>
                <span style={{ marginLeft: 10, fontSize: '1.5em', opacity: 1 }}>
                  <span  >{element[1]}</span> 
                </span>
              </p>
            </div>
          )
        }  else {
          return (
            <p className="GD-p-comid" key={uuidv4()}>  
              <span style={{ opacity: .9 }}>{element[0]}:</span>
              <span style={{ marginLeft: 10, fontSize: '1.3em', opacity: 1 }}>    {element[1]} </span>
            </p>
          )
        }
      })
    })
  }

  const renderPopup = (info: any) => {
    return (
      <Popup
        longitude={Number(info[0].centroid_longitude)}
        latitude={Number(info[0].centroid_latitude)}
        closeButton={true}
        closeOnClick={true}
        className="wqp"
        onClose={() => {
          setPopupInfo(null);
          setActivePopup({ id: null, content: null });
        }}>
        <div className="popup-container" style={{ paddingBottom: 5, lineHeight: '1px' }}>
          <Scrollbars renderThumbVertical={renderThumb} className="summary-scroll" style={{ width: '100%', height: '100%' }}>

            {renderFields(info)}
            <div style={{ marginBottom: 20 }} />
          </Scrollbars>
        </div>
      </Popup>
    );
  }

//#ff000

/*

    <Source
      id={`${id}-layerMI`}
      key={`${id}-layerMI`}
      type="geojson"// @ts-ignore
      data={mIUrl}
    >
      {activePopup && activePopup.id === id && activePopup.content}
      <Layer
        paint={{
          "fill-opacity": .95,
          "fill-outline-color": "darkblue",
          "fill-color": "white",
        }}
        beforeId={settings.defaultBeforeId} 
        type="fill" id={`${id}-layerMI`}
        source={`${id}-layerMI`}
      />


    </Source>


*/

  return (
    <div>





    <Source
      id={`${id}-layer`}
      key={`${id}-layerw`}
      type="geojson"// @ts-ignore
      data={currentUrl}
      >
      {activePopup && activePopup.id === id && activePopup.content}
      <Layer
        paint={{
          "fill-opacity": Math.max(.01, opacity*.5),
          "fill-outline-color": "darkblue",
          "fill-pattern" : [  'match',
                      ['get', 'Category'],
                    'Through Day 3 Limited', "day3limited",
                    'Through Day 3 Considerable', `day3considerable`,
                    'Through Day 3 Catastrophic', `day3catastrophic`,
                    'Through Day 4 Considerable', `day4considerable`,
                    'Days 4-7 Limited', "day4limited",
                    'Through Day 7 Considerable', `day7considerable`,
                    'Through Day 7 Limited', "day7limited",
                    "green"
            ],
          "fill-color": [
                'match',
                    ['get', 'Category'],
                    'Through Day 3 Limited', "#d2efff",
                    'Through Day 3 Considerable', `#669df0`,
                    'Through Day 3 Catastrophic', `#ff4dd7`,
                    'Days 4-7 Considerable', `#669df0`,
                    'Days 4-7 Limited', "#d2efff",
                    'Through Day 7 Considerable', `#669df0`,
                    'Through Day 7 Limited', "#d2efff",
                    'See Text', "yellow",
                    "green"
            ],
        }}
     
        type="fill" id={`${id}-layer`}
        source={`${id}-layer`}
        beforeId={settings.defaultBeforeId}
      />


    </Source>


    <Source
      id={`${id}-layerH`}
      key={`${id}-layerH`}
      type="geojson"// @ts-ignore
      data={hUrl}
    >
  
      <Layer
        paint={{
          "fill-opacity": opacity,
          "fill-outline-color": "transparent",
          "fill-color": [
            'match',
            ['get', 'Hazard_Type'],
            '911 Telephone Outage', 'rgba(192,192,192,255)', 'Administrative Message', 'rgba(192,192,192,255)', 'Air Quality Alert', 'rgba(128,128,128,255)', 'Air Stagnation Advisory', 'rgba(128,128,128,255)', 'Ashfall Advisory', 'rgba(105,105,105,255)', 'Ashfall Warning', 'rgba(169,169,169,255)', 'Avalanche Advisory', 'rgba(205,133,63,255)', 'Avalanche Warning', 'rgba(30,144,255,255)', 'Avalanche Watch', 'rgba(244,164,96,255)', 'Beach Hazards Statement', 'rgba(64,224,208,255)', 'Blizzard Warning', 'rgba(255,69,0,255)', 'Blizzard Watch', 'rgba(173,255,47,255)',  'Blue Alert', 'rgba(255,255,255,255)', 'Brisk Wind Advisory', 'rgba(216,191,216,255)', 'Child Abduction Emergency', 'rgba(255,255,255,255)', 'Civil Danger Warning', 'rgba(255,182,193,255)', 'Civil Emergency Message', 'rgba(255,182,193,255)', 'Coastal Flood Advisory', 'rgba(124,252,0,255)', 'Coastal Flood Statement', 'rgba(107,142,35,255)', 'Coastal Flood Warning', 'rgba(34,139,34,255)', 'Coastal Flood Watch', 'rgba(102,205,170,255)', 'Dense Fog Advisory', 'rgba(112,128,144,255)', 'Dense Smoke Advisory', 'rgba(240,230,140,255)', 'Dust Advisory', 'rgba(189,183,107,255)', 'Dust Storm Warning', 'rgba(255,228,196,255)', 'Earthquake Warning', 'rgba(139,69,19,255)', 'Evacuation - Immediate', 'rgba(127,255,0,255)',  'Excessive Heat Warning', 'rgba(199,21,133,255)', 'Excessive Heat Watch', 'rgba(128,0,0,255)',
               'Extreme Cold Warning', 'rgba(0,0,255,255)', 'Extreme Cold Watch', 'rgba(0,0,255,255)', 'Extreme Fire Danger', 'rgba(233,150,122,255)', 'Extreme Wind Warning', 'rgba(255,140,0,255)', 'Fire Warning', 'rgba(160,82,45,255)', 'Fire Weather Watch', 'rgba(255,222,173,255)', 'Flash Flood Statement', 'rgba(139,0,0,255)', 'Flash Flood Warning', 'rgba(139,0,0,255)', 'Flash Flood Watch', 'rgba(46,139,87,255)', 'Flood Advisory', 'rgba(0,255,127,255)', 'Flood Statement', 'rgba(0,255,0,255)', 'Flood Warning', 'rgba(0,255,0,255)', 'Flood Watch', 'rgba(46,139,87,255)', 'Freeze Warning', 'rgba(72,61,139,255)', 'Freeze Watch', 'rgba(0,255,255,255)', 'Freezing Fog Advisory', 'rgba(0,128,128,255)', 'Freezing Rain Advisory', 'rgba(218,122,214,255)', 'Freezing Spray Advisory', 'rgba(0,191,255,255)', 'Frost Advisory', 'rgba(100,149,237,255)', 'Gale Warning', 'rgba(221,160,221,255)', 'Gale Watch', 'rgba(255,192,203,255)', 'Hard Freeze Warning', 'rgba(148,0,211,255)', 'Hard Freeze Watch', 'rgba(65,105,225,255)', 'Hazardous Materials Warning', 'rgba(75,0,130,255)', 'Hazardous Seas Warning', 'rgba(216,191,216,255)', 'Hazardous Seas Watch', 'rgba(72,61,139,255)', 'Hazardous Weather Outlook', 'rgba(238,232,170,255)', 'Heat Advisory', 'rgba(255,127,80,255)', 'Heavy Freezing Spray Warning', 'rgba(0,191,255,255)', 'Heavy Freezing Spray Watch', 'rgba(188,143,143,255)', 'High Surf Advisory', 'rgba(186,85,211,255)', 'High Surf Warning', 'rgba(34,139,34,255)', 'High Wind Warning', 'rgba(218,165,32,255)', 'High Wind Watch', 'rgba(184,134,11,255)', 'Hurricane Force Wind Warning', 'rgba(205,92,92,255)', 'Hurricane Force Wind Watch', 'rgba(153,50,204,255)', 'Hurricane Local Statement', 'rgba(255,228,181,255)', 'Hurricane Warning', 'rgba(220,20,60,255)', 'Hurricane Watch', 'rgba(255,0,255,255)', 'Hydrologic Advisory', 'rgba(0,255,127,255)', 'Hydrologic Outlook', 'rgba(144,238,144,255)', 'Ice Storm Warning', 'rgba(139,0,139,255)', 'Lake Effect Snow Advisory', 'rgba(72,209,204,255)', 'Lake Effect Snow Warning', 'rgba(0,139,139,255)', 'Lake Effect Snow Watch', 'rgba(135,206,250,255)', 'Lake Wind Advisory', 'rgba(210,180,140,255)', 'Lakeshore Flood Advisory', 'rgba(124,252,0,255)', 'Lakeshore Flood Statement', 'rgba(107,142,35,255)', 'Lakeshore Flood Warning', 'rgba(34,139,34,255)', 'Lakeshore Flood Watch', 'rgba(102,205,170,255)', 'Law Enforcement Warning', 'rgba(192,192,192,255)', 'Local Area Emergency', 'rgba(192,192,192,255)', 'Low Water Advisory', 'rgba(165,42,42,255)', 'Marine Weather Statement', 'rgba(255,239,213,255)', 'Nuclear Power Plant Warning', 'rgba(75,0,130,255)', 'Radiological Hazard Warning', 'rgba(75,0,130,255)', 'Red Flag Warning', 'rgba(255,20,147,255)', 'Rip Current Statement', 'rgba(64,224,208,255)', 'Severe Thunderstorm Warning', 'rgba(255,165,0,255)', 'Severe Thunderstorm Watch', 'rgba(219,112,147,255)', 'Severe Weather Statement', 'rgba(0,255,255,255)', 'Shelter In Place Warning', 'rgba(250,128,114,255)', 'Short Term Forecast', 'rgba(152,251,152,255)', 'Small Craft Advisory', 'rgba(216,191,216,255)', 'Small Craft Advisory For Rough Bar', 'rgba(216,191,216,255)', 'Small Craft Advisory for Hazardous Seas', 'rgba(216,191,216,255)', 'Small Craft Advisory for Winds', 'rgba(216,191,216,255)', 'Snow Squall Warning', 'rgba(199,21,133,255)', 'Special Marine Warning', 'rgba(255,165,0,255)', 'Special Weather Statement', 'rgba(255,228,181,255)', 'Storm Surge Warning', 'rgba(181,36,247,255)', 'Storm Surge Watch', 'rgba(219,127,247,255)', 'Storm Warning', 'rgba(148,0,211,255)', 'Storm Watch', 'rgba(255,228,181,255)', 'Tornado Warning', 'rgba(255,0,0,255)', 'Tornado Watch', 'rgba(255,255,0,255)', 'Tropical Depression Local Statement', 'rgba(255,228,181,255)', 'Tropical Storm Local Statement', 'rgba(255,228,181,255)', 'Tropical Storm Warning', 'rgba(178,34,34,255)', 'Tropical Storm Watch', 'rgba(240,128,128,255)', 'Tsunami Advisory', 'rgba(210,105,30,255)', 'Tsunami Warning', 'rgba(253,99,71,255)', 'Tsunami Watch', 'rgba(255,0,255,255)', 'Typhoon Local Statement', 'rgba(255,228,181,255)', 'Typhoon Warning', 'rgba(220,20,60,255)', 'Typhoon Watch', 'rgba(255,0,255,255)', 'Volcano Warning', 'rgba(47,79,79,255)', 'Wind Advisory', 'rgba(210,180,140,255)', 'Wind Chill Advisory', 'rgba(175,238,238,255)', 'Wind Chill Warning', 'rgba(176,196,222,255)', 'Wind Chill Watch', 'rgba(95,158,160,255)', 'Winter Storm Warning', 'rgba(255,105,180,255)', 'Winter Storm Watch', 'rgba(70,130,180,255)', 'Winter Weather Advisory', 'rgba(123,104,238,255)',
            "transparent"
          ]
        }}
        layout={{'fill-sort-key': ['-', ['get', 'objectid']]}}
        type="fill" id={`${id}-layerH`}
        source={`${id}-layerH`}
        beforeId={settings.defaultBeforeId}
      />

      {activePopup && activePopup.id === id && activePopup.content}
    </Source>


    <Source
      id={`${id}-layerS`}
      key={`${id}-layerS`}
      type="geojson"// @ts-ignore
      data={sfUrl}
    >
      {activePopup && activePopup.id === id && activePopup.content}
      <Layer
        paint={{
          "fill-opacity": .45,
          "fill-outline-color": "darkblue",
          "fill-color": [
                'match',
                    ['get', 'outlook'],
                    'Likely', `#cc33ff`,
                    'Possible', `yellow`,
                    'Occurring', `red`,
                    'minor', `#ff9900`,
                    "green"
            ],
        }}
        beforeId={settings.defaultBeforeId} 
        type="fill" id={`${id}-layerS`}
        source={`${id}-layerS`}
      />


    </Source>




      <Source
        id={`${id}-layera`}
        key={`${id}-layera`+'currentRange'}
        type="raster"
        tiles={[imageUrl]}>
        <Layer      
          beforeId={settings.defaultBeforeId}
          paint={{ 'raster-opacity': opacity }}
          type="raster" id={`${id}-layerR`}
          source={`${id}-layera`}       
        />
      </Source>

    <Source
      id={`${id}-layerM`}
      key={`${id}-layerM`}
      type="geojson"// @ts-ignore
      data={mUrl}
    >
      {activePopup && activePopup.id === id && activePopup.content}
      <Layer
        paint={{
          "line-opacity": opacity,
          "line-color": [
                'match',
                    ['get', 'Max_Status'],
                    'Major', `#cc33ff`,
                    'Action', `yellow`,
                    'Moderate', `#ff0000`,
                    'Minor', `#ff9900`,
                    "green"
            ],
          "line-width": 3
        }}
        
        type="line" id={`${id}-layerM`}
        source={`${id}-layerM`}
      />


    </Source>




    <Source
      id={`${id}-layerG`}
      key={`${id}-layerwG`}
      type="geojson"// @ts-ignore
      data={gaugeUrl}
    >
  
      <Layer
        paint={{
          "circle-color": [
                'match',
                    ['get', 'Flood_Status'],
                    'major', `#cc33ff`,
                    'action', `yellow`,
                    'moderate', `#ff0000`,
                    'minor', `#ff9900`,
                    "green"
            ],
            "circle-stroke-width" : 9,
            "circle-stroke-opacity" : 0


        }}
     
        type="circle" id={`${id}-layerG`}
        source={`${id}-layerG`}

      />


    </Source>



    <Source //Forecast Gauge layer
      id={`${id}-layerGF`}
      key={`${id}-layerwGF`}
      type="geojson"// @ts-ignore
      data={gaugeFUrl }
    >
  
      <Layer
        paint={{
          "circle-color": [
                'match',
                    ['get', 'Flood_Status'],
                    'major', `rgba(204, 51, 255, 0)`,
                    'action', `yellow`,
                    'moderate', `rgba(255, 153, 153, .2)`,
                    'minor', `#ff9900`,
                    "green"
            ],
            "circle-stroke-width" : 4,
            "circle-radius" : 5,
            "circle-opacity" : .1,
            "circle-stroke-opacity" : .5,
            "circle-stroke-color" : [
                'match',
                    ['get', 'Flood_Status'],
                    'major', `#cc33ff`,
                    'action', `yellow`,
                    'moderate', `#ff0000`,
                    'minor', `#ff9900`,
                    "green"
            ],
        }}
     
        type="circle" id={`${id}-layerGF`}
        source={`${id}-layerGF`}
      />


    </Source>




    </div>
  )
}

export default FHO